/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
  $(".tags-collections a").click(function(e){
    e.preventDefault();
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    let href = $(this).attr('href');
    console.log(href)
    jQuery.ajax({
      url: href,
      type: 'GET',
      success: function(res) {
             window.history.pushState({"html":res.html,"pageTitle":res.pageTitle},"", href);

          let val = $(res).find('.ProductList').html();
          let fil = $(res).find('#collection-filter-drawer').html();
          $('#collection-filter-drawer').empty().append(fil);
          $('.ProductList').empty().append(val);
          $('.ProductItem ').css("visibility","inherit");
          $('.ProductItem ').css("opacity","1");
          $('.ProductItem ').css("transform","matrix(1, 0, 0, 1, 0, 0)");
      }
    });
  });



// $('.varSliderItem').slick({
//     //  dots: true,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 3,
//     slidesToScroll: 3,
//     //  autoplay: true,
//     autoplaySpeed: 2000,
//     nextArrow: '.var-next-button',
//     prevArrow: '.var-prev-button',
// });
setTimeout(function() {
	$('.Newsletter_cstm').removeClass('hide');
}, 2000);
$("#ClubsearchInput").on("input", function() {
    var searchText = $(this).val().toLowerCase();
    $(".clubs-search").parent().hide();
    $(".clubs-search:contains('" + searchText + "')").parent('.CollectionItem').show();
});